// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__2FPkn"};